import { IconCombinedProps } from './types';

const usePresenter = (props: IconCombinedProps): IconCombinedProps => {
  return props;
};

export default usePresenter;
